import {
  Box,
  Container,
  Image,
  Link,
  Text,
  HStack,
  Stack,
} from '@chakra-ui/react';
import { FooterContent } from './Content';

export function Footer() {
  return (
    <Box backgroundColor="black">
      <Container
        maxW={{ mobile: '100vw', desktop: '1440px' }}
        px={{ mobile: '4', desktop: '10' }}
        py="12"
      >
        <Stack>
          {/* Links */}
          <FooterContent />

          <HStack
            borderTopWidth="1px"
            borderTopColor="whiteAlpha.300"
            py="10"
            mt="10"
            color="white"
            justifyContent="space-between"
            alignItems="center"
          >
            <HStack
              alignItems="center"
              gap="16"
              flexShrink="0"
            >
              <Image
                src={'/eo/logos/logo-white.svg'}
                maxW={{ mobile: '100px', desktop: '140px' }}
              />
              <HStack color="whiteAlpha.700" alignItems="center" flexShrink="0">
                <Link href="tel:0771551000">
                  <Text size="sm">0771-551 000</Text>
                </Link>

                <Text size="sm">•</Text>
                <Link href="mailto:mail@erikolsson.se">
                  <Text size="sm">mail@erikolsson.se</Text>
                </Link>

                <Text size="sm">•</Text>
                <Text size="sm">Kundtjänst öppen mån-fre: 9-17 Sön: 12-16</Text>
              </HStack>
            </HStack>
            <HStack
              alignItems="center"
              color="whiteAlpha.700"
            >
              <Link href="/p/personuppgiftspolicy">
                <Text size="sm">integritetspolicy</Text>
              </Link>
              <Text size="sm">•</Text>
              <Link href="/b/visselblasarpolicy">
                <Text size="sm">visselblåsarpolicy</Text>
              </Link>
            </HStack>
          </HStack>
        </Stack>
      </Container>
    </Box>
  );
}
